<div class="row justify-content-center">
  <div class="col-auto m-4">
    <div class="login-container">
      <div class="row justify-content-center mb-4">
        <div class="col-auto d-flex">
          <div class="form-header">
            <h2>Request demo token</h2>
            <div class="form-header-description" *ngIf="!demoRequestSuccess">
              We've created the test data to demonstrate the possibilities of
              our system.<br />
              Type your email and we will send you the link to our demo portal.
            </div>

            <div
              class="form-header-description text-success"
              *ngIf="demoRequestSuccess"
            >
              <i class="bi bi-cloud-check"></i>
              Please check your email box. We've just sent you an email with the
              demo portal link.
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!demoRequestSuccess">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="row justify-content-center mb-4">
            <div class="col-auto">
              <div class="form-item">
                <label for="email" class="form-label">Email Address</label>
                <input
                  [ngClass]="{ 'input-error': isControlInvalid('email') }"
                  type="email"
                  class="form-control"
                  id="email"
                  formControlName="email"
                  autocomplete="email"
                />
              </div>
              <div
                *ngIf="isControlInvalid('email')"
                class="form-hint mt-1 input-error"
              >
                Invalid email
              </div>
            </div>
          </div>
          <!-- Turnstile CAPTCHA -->
          <div class="row justify-content-center mb-4">
            <div class="col-auto">
              <app-turnstile
                [siteKey]="siteKey"
                (tokenChange)="onTurnstileToken($event)"
                #turnstileWidget
              ></app-turnstile>
            </div>
          </div>

          <div class="row justify-content-center mb-4">
            <div class="col-auto">
              <div class="form-item">
                <button
                  class="btn w-100 btn-submit"
                  [ngClass]="{ 'btn-disabled': !isFormReady || isLoading || !turnstileToken }"
                  type="submit"
                  [disabled]="!isFormReady || isLoading || !turnstileToken"
                >
                  Request Demo Access
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
